import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
import { NUMPIC } from '@/util/constant';
export default {
  props: {
    numSrc: {
      type: String,
      default: ''
    },
    num: {
      type: Number,
      default: -1
    },
    contSrc: {
      type: String,
      default: ''
    }
  },
  computed: {
    numPic: function numPic() {
      return this.numSrc || NUMPIC[this.num];
    }
  }
};